import * as React from 'react';
import { ComponentProps } from '../common/types';
import { ValidationSummary, ValidationProps } from 'ui';

import styles from './fluid-panel.scss';

export interface FluidPanelProps extends ComponentProps {
  displayBottomLine?: boolean;
  validation?: ValidationProps;
  children?: React.ReactNode;
}

export const FluidPanel = (props:FluidPanelProps) => {
  const {validation, children} = props;
  const childCount = React.Children.count(children);
  const separatedChildren = React.Children.map(children, (child, i) => {
    const childWithoutSeparator = <li className={styles.withoutDelimiter}>
                                    {child}
                                  </li>;
    return (i === childCount - 1) ?  childWithoutSeparator :  <li className={styles.withDelimiter}> {child}</li>;
  });

  return (
      <div id={props.componentId} className={`fluid-panel ${styles.fluidPanel}`}>
        <ValidationSummary validationError={validation}/>
        <ul>
          {separatedChildren}
        </ul>
      </div>
  );
};
